import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import Vue from 'vue'
import '../../plugins/axios'
import { AUTH_LOGOUT } from '../actions/auth'
import store from '../../store'
import axios from 'axios'

Vue.use(axios)

const state = {
  status: '',
  profile: {},
  blockedResidenceData: null,
  showBlockedResidenceDialog: false
}

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.username,
  getBlockedResidenceData: state => state.blockedResidenceData,
  getShowBlockedResidenceDialog: state => state.showBlockedResidenceDialog
}

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST)
    const config = {
      method: 'get',
      url: 'https://residencial-services.intrare.app/users/me/',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Token ' + store.getters.getToken
      }
    }
    return axios(config).then(resp => {
      // Caso 1: Domicilio bloqueado (HTTP 200), con o sin otros domicilios disponibles
      if (resp.data.is_blocked_in_active_residence) {
        commit('SET_BLOCKED_RESIDENCE_DATA', {
          message: resp.data.message,
          availableResidences: resp.data.available_residences || []
        })
        commit('SET_SHOW_BLOCKED_RESIDENCE_DIALOG', true)
        commit(USER_SUCCESS, resp.data)
        return
      }

      if (localStorage.getItem('enable_2fa')) {
        console.log('OTPPPP')
      } else {
        console.log('NOOOOO OTP')
        if (resp.data.enable_2fa) {
          const config = {
            method: 'post',
            url: 'https://residencial-services.intrare.app/users/otp',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(resp => {
            console.log('OTP Enviado')
          }).catch(resp => {
            console.log('OTP Error')
          })
        }
      }
      commit(USER_SUCCESS, resp.data)
    }).catch(resp => {
      // Caso 2: Domicilio bloqueado sin domicilios disponibles (HTTP 403)
      if (resp.response && resp.response.status === 403 && resp.response.data.error === 'blocked') {
        commit('SET_BLOCKED_RESIDENCE_DATA', {
          message: resp.response.data.message,
          error: resp.response.data.error,
          defaulter: resp.response.data.defaulter
        })
        commit('SET_SHOW_BLOCKED_RESIDENCE_DIALOG', true)
        commit(USER_SUCCESS, resp.response.data)
        return
      }

      commit(USER_ERROR)
      dispatch(AUTH_LOGOUT)
    })
  },

  clearBlockedResidenceDialog: ({ commit }) => {
    commit('SET_SHOW_BLOCKED_RESIDENCE_DIALOG', false)
    commit('SET_BLOCKED_RESIDENCE_DATA', null)
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'profile', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
    state.blockedResidenceData = null
    state.showBlockedResidenceDialog = false
  },
  SET_BLOCKED_RESIDENCE_DATA: (state, data) => {
    state.blockedResidenceData = data
  },
  SET_SHOW_BLOCKED_RESIDENCE_DIALOG: (state, show) => {
    state.showBlockedResidenceDialog = show
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
